<template>
    <LeaveRequestList :activeTabIndex="0" title="Pending" />
</template>

<script>
import LeaveRequestList from "./leave-request-list.vue"
export default { components: { LeaveRequestList } }
</script>
